import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ColdIcon from "../../Icons/ColdIcon";
import HotIcon from "../../Icons/HotIcon";
import { useMutation } from "@tanstack/react-query";
import { FreezeStudent } from "../../../api/Students/FreezeStudent";
import { queryClient } from "../../../main";
const StudentsFreezeRow = ({
  fullName,
  email,
  phone,
  country,
  studentId,
  courseId,
  frozen,
}: {
  fullName: string;
  email: string;
  phone: string;
  country: string;
  studentId: string;
  courseId: string;
  frozen: boolean;
}) => {
  const { mutate: mutateStatus } = useMutation({
    mutationFn: ({
      isFreeze,
      studentId,
      courseId,
    }: {
      isFreeze: boolean;
      studentId: string;
      courseId: string;
    }) => FreezeStudent({ isFreeze }, studentId, courseId ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["studentsbycourse"] });
      toast.success("Student Status Changed Successfully");
    },
    onError: (error) => {
      toast.error("Failed to update student status");
      console.error(error);
    },
  });

  const handleChangeStatus = () => {
    mutateStatus({
      isFreeze: !frozen,
      studentId: studentId,
      courseId: courseId,
    });
  };

  return (
    <>
      <tr>
        <Link className="w-full" to={`/dashboard/students/${studentId}`}>
          <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
            <div className="rounded-full text-left py-0.5 text-sm font-semibold flex items-center gap-4">
              {fullName}
            </div>
          </td>
        </Link>
        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {email}
          </div>
        </td>
        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {phone}
          </div>
        </td>
        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {country}
          </div>
        </td>
        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div
            className={`inline-flex uppercase rounded-full text-left py-0.5 text-sm font-semibold ${
              frozen ? "text-blue-500" : "text-red-500"
            }`}
          >
            {frozen ? "Frozen" : "Unfrozen"}
          </div>
        </td>
        <td className="px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="flex rounded-xl justify-center items-center bg-[#FAFBFD] border-[#D5D5D5] border py-3 text-sm font-semibold">
            <button onClick={handleChangeStatus}>
              {frozen ? <HotIcon /> : <ColdIcon />}
            </button>
          </div>
        </td>
      </tr>
    </>
  );
};

export default StudentsFreezeRow;
